import { environment } from '@env';

export const environmentFactory = () => {
  const url = window.location.href;
  const env = { ...environment };
  // Lógica para verificar la URL y modificar el environment según corresponda
  if (url.includes('//localhost') || url.includes('//35.181.18.6')) {
    //Localhost
    env.apiBaseUrl = env.apiBaseUrl_dev;
  } else if (url.includes('//preproduccio.guiescliniques.sem.gencat')) {
    //Preproducción
    env.apiBaseUrl = env.apiBaseUrl_pre;
  } else if (url.includes('//guiescliniques.sem.gencat')) {
    //Producción
    env.apiBaseUrl = env.apiBaseUrl_pro;
  } else {
    //Default
    env.apiBaseUrl = env.apiBaseUrl_pro;
  }
  return env;
};
